import PropTypes from 'prop-types';
import React from 'react';
import ReactSelect from 'react-select';
import styled from 'styled-components';

import connect from 'components/lib/connect';

const StyledPlaceholder = styled.em`
  color: ${p => p.theme.colors.gray600};
`;

export function SelectRelationshipMenu({ className, labelId, updateRelationship, relationshipOptions }) {
  return (
    <ReactSelect
      className={className}
      clearable={false}
      searchable={false}
      value={labelId}
      onChange={updateRelationship}
      options={relationshipOptions}
      placeholder={<StyledPlaceholder>blank</StyledPlaceholder>}
    />
  );
}

SelectRelationshipMenu.propTypes = {
  className: PropTypes.string,
  labelId: PropTypes.string,
  relationshipOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ).isRequired,
  updateRelationship: PropTypes.func.isRequired,
};

function mapStateToProps({ getProvider }, props) {
  const labelProvider = getProvider('relationshipLabels');
  let relationshipOptions = [{ label: <StyledPlaceholder>blank</StyledPlaceholder>, value: '' }].concat(
    labelProvider.findAll().map(l => {
      return { label: l.displayName, value: l.id };
    })
  );
  return {
    relationshipOptions,
  };
}

const SelectRelationshipMenuContainer = connect(mapStateToProps)(SelectRelationshipMenu);
export default SelectRelationshipMenuContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/menu/pin_to_customer/select_relationship_menu.jsx